import { api } from '@/portal-api.definition';
import { queryOptions } from '@tanstack/react-query';
import { useNosIdQuery } from './base.hooks';

export const devicesQueryOptions = (sa: string) =>
  queryOptions({
    queryKey: ['devices', sa],
    queryFn: () =>
      api.get('/api/v1/device-management/:accountId/devices', { params: { accountId: sa } }),
  });

export function useGetDevices(sa: string) {
  return useNosIdQuery(devicesQueryOptions(sa));
}
